import { Component, OnInit, ViewChild } from "@angular/core";
import { SysAdminService } from "../services/sysadmin.service";
import { SchoolsToChangeModel } from "../user-group-assignment/user-group-assign-school/SchoolsToChangeModel";
import { ManageSchoolContainerSchoolTableComponent } from "./manage-school-container-school-table/manage-school-container-school-table.component";
import { ManageSchoolContainerUserTableComponent } from "./manage-school-container-user-table/manage-school-container-user-table.component";

@Component({
	selector: "app-manage-school-container",
	templateUrl: "./manage-school-container.component.html",
	styleUrls: ["./manage-school-container.component.css"],
})
export class ManageSchoolContainerComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService) {}

	ngOnInit(): void {}

	/////////////////////////////////////
	// Data
	/////////////////////////////////////

	SelectedContainer: any;
	UpdateSchoolCount: any = false;

	@ViewChild(ManageSchoolContainerUserTableComponent)
	userGroupComp: ManageSchoolContainerUserTableComponent;

	@ViewChild(ManageSchoolContainerSchoolTableComponent)
	schoolRef: ManageSchoolContainerSchoolTableComponent;

	/////////////////////////////////////

	/////////////////////////////////////
	// Events
	/////////////////////////////////////

	onContainerSelected(val) {
		this.SelectedContainer = val;
	}

	onUpdateSchoolCount(val) {
		this.UpdateSchoolCount = !this.UpdateSchoolCount;
	}

	onUpdateUserGroups(val) {
		var SchoolIDs = val;

		var UserGroups = this.userGroupComp.lstUserGroups;

		for (var i = 0; i < UserGroups.length; i++) {
			//Create Query Data
			let data: SchoolsToChangeModel = {
				UserGroupID: UserGroups[i].UserGroupID,
				SchoolIDs: SchoolIDs,
			};

			//Call SP
			var result = this.sysAdminService.UserGroupAddSchools(data);
			result.subscribe(
				(response) => {
					if (response) {
					} else {
						// console.log("Could not add schools");
					}
				},
				(error) => {}
			);
		}
	}

	/////////////////////////////////////
}
